import Icon from "../Icon";
import { fmtHours } from "../../utils";

// Píldora de un tipo de entrada en el gestor de tipos.
// Solo presenta y abre el modal — la edición vive en TipoEntradaModal
// para que nombre, color e icono se guarden en una sola operación.
export default function TypePill({ name, color, icon, count = 0, hours = 0, archived = false, onEdit }) {
  return (
    <button className="btn" onClick={onEdit} title={`Editar "${name}"`}
      style={{display:"inline-flex",alignItems:"center",gap:6,padding:"4px 10px",borderRadius:20,
        background:archived?"var(--bg)":color+"18",
        border:`1px solid ${archived?"var(--border)":color+"44"}`,
        borderStyle:archived?"dashed":"solid",
        cursor:"pointer",fontFamily:"var(--font)",opacity:archived?.7:1}}>
      {icon
        ? <Icon name={icon} size={11} color={archived?"var(--text3)":color}/>
        : <span style={{width:6,height:6,borderRadius:"50%",background:archived?"var(--text3)":color}}/>}
      <span style={{fontSize:11,fontWeight:600,color:archived?"var(--text3)":color}}>{name}</span>
      {count>0 && (
        <span style={{fontSize:10,fontWeight:700,padding:"1px 6px",borderRadius:20,
          background:archived?"var(--surface2)":color+"22",color:archived?"var(--text3)":color,whiteSpace:"nowrap"}}>
          {count} · {fmtHours(hours)}
        </span>
      )}
      {archived && (
        <span style={{fontSize:10,fontWeight:800,letterSpacing:".05em",color:"var(--text3)"}}>ARCHIVADO</span>
      )}
      <Icon name="pencil" size={9} color={archived?"var(--text3)":color} style={{opacity:.6}}/>
    </button>
  );
}
